import {Component, ViewEncapsulation} from '@angular/core';
import {AdvisorComponent} from "../advisor.component";
import {TranslateService} from "@ngx-translate/core";
import {Router} from "@angular/router";
import {EmbedService} from "../services/embed.service";
import {TrackingService} from "../services/tracking.service";
import {environment} from "../../environments/environment";
import {HeizcheckBackendService} from "./services/backend.service";

/**
 * The heizcheck component as wrapper for all steps of the application.
 * Attention: The mentioned scss file here will be replaced in angulaar.json and will not be included
 * in the deployment package. This is for development purpose only.
 */
@Component({
    selector: 'heizcheck-root',
    templateUrl: './heizcheck.component.html',
    styleUrls: environment.production === true ? [] : [
        '../../../../scss/heizcheck.scss',
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class HeizcheckComponent extends AdvisorComponent {


  /**
   * constructor
   * @param translate
   * @param router
   * @param embedService
   * @param trackingService
   */
  constructor(public translate: TranslateService, protected router: Router, protected embedService: EmbedService, protected trackingService: TrackingService, protected backendService: HeizcheckBackendService) {
    super(translate, router, embedService, trackingService);

    this.backendService.setAdvisor('heizcheck');
  }


}
